import { FunctionComponent } from 'react'
import { Daycare } from '@/types/Daycare'
import profileStyles from '../DaycareProfileHandler.module.scss'
import StaffAutolink from './staffAutolink/staffAutolink'
import ParentAutolink from './parentAutolink/parentAutolink'

interface AutolinkSettingsProps {
    daycare: Daycare
}

const AutolinkSettings: FunctionComponent<AutolinkSettingsProps> = ({ daycare }: AutolinkSettingsProps) => {
    return (
        <div className={profileStyles.PagePosition}>
            <ParentAutolink daycare={daycare} />
            {daycare.staffAccess && <StaffAutolink daycare={daycare} />}
        </div>
    )
}

export default AutolinkSettings
